<template>
  <v-menu v-model="display" :close-on-content-click="false" offset-y>
    <template v-slot:activator="{ on }">
      <span v-if="!trackingNumber || (!details || !details.length) && !isServer">
        <slot />
        <span v-if="!$slots.default">{{tracking}}</span>
      </span>
      <a v-else :title="$t('viewTrackRecord')" linkify v-on="on">
        <slot />
        <span v-if="!$slots.default">{{tracking}}</span>
      </a>
      <v-tooltip top v-if="!!trackStatus">
        <template v-slot:activator="{ on }">
          <p class="text-xs-center cursor-pointer" v-on="on">{{trackStatus.toLowerCase()}}</p>
        </template>
        <span>{{trackDescription}}</span>
      </v-tooltip>
    </template>
    
    <v-card>
      <v-card-title class="py-2">
        <span>{{ $t('trackingDetails') }}</span>
        <v-spacer></v-spacer>
        <v-btn 
          v-if="isServer" 
          icon 
          small 
          @click="fetchTrackingDetails"
          :loading="loading"
          :disabled="!tracking"
        >
          <v-icon>refresh</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <div v-if="error" class="text-center py-4 text-error">
          <v-icon color="error" class="mb-2">error</v-icon>
          <div>{{ error }}</div>
        </div>
        <v-data-table
          v-else
          :loading="loading"
          :headers="[
            { text: this.$t('time'), align: 'left', sortable: false, value: 'timestamp' },
            { text: this.$t('event'), align: 'left', sortable: false, value: 'desc' },
            { text: this.$t('address'), align: 'left', sortable: false, value: 'address'}
          ]"
          :items="trackingDetails"
          item-key="serviceType"
          hide-actions
        >
          <template v-slot:items="{ item }">
            <td>{{item.timestamp && formatFedexLocalScanTime(item)}}</td>
            <td>{{item.desc}}</td>
            <td>{{item.address}}</td>
          </template>
          <template slot="no-data">
            <v-flex row wrap text-xs-center>
              {{ this.$t('noEventsOfThisTracking') }}
            </v-flex>
          </template>
        </v-data-table>
      </v-card-text>
        <v-flex text-xs-center>{{ $t('packageStatusUpdateHint') }}</v-flex>
      <v-card-actions>
        <a v-if="carrier" linkify @click="trackOnCarrierSite">{{ $t('trackOnCarrierSite', { tracking }) }}</a>
        <v-spacer></v-spacer>
        <v-btn color="primary" flat @click="display = false">{{ $t('close') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  name: 'LabelTrackingDetailWidget',
  data () {
    return {
      display: false,
      loading: false,
      error: null,
      serverDetails: []
    }
  },
  computed: {
    tracking () {
      return this.trackingNumber || (this.$slots.default && this.$slots.details.text) || ''
    },
    trackingDetails () {
      return this.isServer ? this.serverDetails : this.$props.details
    }
  },
  watch: {
    display (newVal) {
      if (newVal && this.isServer && !this.$props.details.length) {
        this.fetchTrackingDetails()
      }
    }
  },
  methods: {
    formatFedexLocalScanTime (item) {
      if (!item?.timestamp) return ''
      if (!item?.offset) return new Date(item.timestamp).toLocaleString()
      const utcMs = new Date(item.timestamp).getTime()
      if (Number.isNaN(utcMs)) return ''

      const offsetMatch = String(item.offset || '+00:00').match(
        /^([+-])(\d{2}):(\d{2})$/
      )

      let offsetMinutes = 0

      if (offsetMatch) {
        const sign = offsetMatch[1] === '-' ? -1 : 1
        offsetMinutes =
          sign * (Number(offsetMatch[2]) * 60 + Number(offsetMatch[3]))
      }

      const localDate = new Date(utcMs + offsetMinutes * 60 * 1000)

      return localDate.toLocaleString('en-US', {
        timeZone: 'UTC',
        hour12: true,
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        second: '2-digit'
      })
    },
    async fetchTrackingDetails () {
      if (!this.tracking) {
        this.error = this.$t('noTrackingNumber')
        return
      }
      
      this.loading = true
      this.error = null
      
      try {
        const response = await this.$store.dispatch('getApiTrackingEvents', { trackingNumbers: [this.tracking] })
        this.serverDetails = response.data?.activityDetails || []
      } catch (err) {
        this.error = err.response?.data?.message || this.$t('fetchTrackingError')
      } finally {
        this.loading = false
      }
    },
    trackOnCarrierSite () {
      const sites = {
        usps: 'https://tools.usps.com/go/TrackConfirmAction?tRef=fullpage&tLc=2&text28777=&tLabels=' + this.tracking,
        fedex: `https://www.fedex.com/fedextrack/?trknbr=${this.tracking}`,
        ups: `https://www.ups.com/track?tracknum=${this.tracking}`,
        dhl: `https://www.dhl.com/cn-en/home/tracking.html?locale=true&tracking-id=${this.tracking}&submit=1`
      }
      window.open(sites[this.carrier.toLowerCase()])
    }
  },
  props: {
    trackingNumber: String,
    status: String,
    carrier: String,
    details: {
      type: Array,
      default: () => [] // data like: {timestamp, status, desc, address}
    },
    trackStatus: {
      type: String,
      default: ''
    },
    isServer: {
      type: Boolean,
      default: false
    },
    trackDescription: {
      type: String,
      default: ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/LabelTrackingDetailWidget.vue